<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="appStore.sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
      v-if="!settingsStore.topNav"
    />
    <top-nav
      id="topmenu-container"
      class="topmenu-container"
      v-if="settingsStore.topNav"
    />

    <div class="right-menu">
      <template v-if="appStore.device !== 'mobile'">
        <!-- <header-search id="header-search" class="right-menu-item" /> -->

        <!-- <el-tooltip content="源码地址" effect="dark" placement="bottom">
          <ruo-yi-git id="ruoyi-git" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <!-- <el-tooltip content="文档地址" effect="dark" placement="bottom">
          <ruo-yi-doc id="ruoyi-doc" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>

        <el-tooltip content="网球馆-开放时间" effect="dark" placement="bottom">
          <!-- <el-cascader
            style="width: 200px; margin-top: 10px"
            v-model="pageData.defaultValue"
            :options="pageData.projectList"
            @change="handleChange"
          ></el-cascader> -->
        </el-tooltip>
        <!-- :style="{ opacity: pageData.projectList.length == 1 ? '0' : '1' }" -->
        <el-select
          v-if="pageData.projectList.length > 1"
          style="width: 200px; margin-top: 10px; margin-right: 10px"
          v-model="pageData.projectId"
          placeholder="请选择项目"
          @change="projectCall()"
          filterable
        >
          <!-- @change="projectListCall()" -->
          <el-option
            v-for="dict in pageData.projectList"
            :key="dict.projectId"
            :label="dict.projectName"
            :value="dict.projectId"
          ></el-option>
        </el-select>
        <!-- &&
            useUserStore().permissions[0] == '*:*:*' -->
        <el-select
          v-if="
            pageData.projectList.length > 1 
          "
          style="width: 200px; margin-top: 10px"
          v-model="pageData.roleId"
          @change="roleCall()"
          placeholder="请选择排序角色"
          filterable
        >
          <el-option
            v-for="dict in pageData.roleList"
            :key="dict.roleId"
            :label="dict.roleName"
            :value="dict.roleId"
          ></el-option>
        </el-select>
      </template>
      <div class="avatar-container">
        <el-dropdown
          @command="handleCommand"
          class="right-menu-item hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <img :src="userStore.avatar" class="user-avatar" />
            <el-icon><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>个人中心</el-dropdown-item>
              </router-link>
              <el-dropdown-item
                command="setLayout"
                v-if="settingsStore.showSettings"
              >
                <span>布局设置</span>
              </el-dropdown-item>
              <el-dropdown-item command="clearCache">
                <span>清理缓存</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { listRole } from "@/modules/huyu-framework/backend/api/system/role";
import auth from "@/modules/huyu-framework/backend/plugins/auth";

import { ElMessageBox } from "element-plus";
import Breadcrumb from "@/modules/huyu-framework/backend/components/Breadcrumb";
import TopNav from "@/modules/huyu-framework/backend/components/TopNav";
import Hamburger from "@/modules/huyu-framework/backend/components/Hamburger";
import Screenfull from "@/modules/huyu-framework/backend/components/Screenfull";
import SizeSelect from "@/modules/huyu-framework/backend/components/SizeSelect";

import useAppStore from "@/store/modules/app";
import useUserStore from "@/store/modules/user";
import useSettingsStore from "@/store/modules/settings";
import { getInfo } from "@/modules/huyu-framework/backend/api/login";
import {
  clearAllClientCache,
  clearSessionCache,
} from "@/modules/huyu-framework/backend/utils/clientCache";
import { listModuleList } from "@/modules/huyu-framework/backend/api/project/moduleList";
import { getRouters } from "@/modules/huyu-framework/backend/api/menu";
import { onMounted, reactive } from "vue";
import usePermissionStore from "@/store/modules/permission";
import useDeviceStore from "@/store/modules/device";
// import { useDynamicTitle } from "@/modules/huyu-framework/backend/utils/dynamicTitle";

const permissionStore = usePermissionStore();
const router = useRouter();
onMounted(async () => {
  await getInfoApi();

  // await useDynamicTitle();
});

const appStore = useAppStore();
const userStore = useUserStore();
const settingsStore = useSettingsStore();
let pageData = reactive({
  projectList: [],
  moduleList: [],
  total: 0,
  projectId: null,
  defaultValue: null,
  roleId: -1,
});

async function getInfoApi() {
  let projects = JSON.parse(localStorage.getItem("projects"));
  let projectId = localStorage.getItem("projectId");

  if (projectId != null && projectId != undefined && projectId != "") {
    pageData.projectId = Number(projectId);
    localStorage.setItem("loginId", projectId);
  } else {
    pageData.projectId = Number(projects[0].projectId);
  }

  projects.forEach((item) => {
    item.value = item.projectId;
    item.label = item.projectName + "(" + item.projectId + ")";
  });
  // response.projects.unshift({ label: "全部", value: undefined });
  pageData.projectList = projects;

  pageData.total = projects.length;

  let data = pageData.projectList.find(
    (item) => item.projectId == pageData.projectId,
  );

  // 修改logo旁边

  useDeviceStore().useDynamicTitle(data.projectName, data.projectLogo);

  await projectCall();
  let roleId = localStorage.getItem("roleId");
  if (roleId != null && roleId != undefined && roleId != "") {
    pageData.roleId = Number(roleId);
  }
}

async function projectListCall(res) {
  console.log("切换项目", pageData);

  localStorage.setItem("projectId", pageData.projectId);

  const account = userStore.name;
  if (account) {
    let lastProjectMap = {};
    try {
      lastProjectMap = JSON.parse(localStorage.getItem("lastProject") || "{}");
    } catch (e) {
      lastProjectMap = {};
    }
    lastProjectMap[account] = pageData.projectId;
    localStorage.setItem("lastProject", JSON.stringify(lastProjectMap));
  }

  let data = pageData.projectList.find(
    (item) => item.projectId == pageData.projectId,
  );

  // 修改logo旁边
  useDeviceStore().updataPageTitle(data.projectName);
  useDeviceStore().useDynamicTitle(data.projectName, data.projectLogo);

  let data1 = await listModuleList({
    pageNum: 1,
    pageSize: 100,
    projectId: pageData.projectId,
  });

  localStorage.setItem("modules", JSON.stringify(data1.rows));

  // permissionStore.generateRoutes({
  //   projectId: pageData.projectId,
  // });
  //修改顶部
  window.getDetail({
    projectName: data.projectName,
    // projectLogo:'@/modules/huyu-framework/backend/assets/logo/虎鱼通用预约.png'
  });

  // sessionStorage.clear();

  // 设置项目切换标志，用于清除页面缓存
  sessionStorage.setItem("projectChanged", "true");
  // 清除旧路由缓存，避免切换项目后导航到旧项目的路由
  sessionStorage.removeItem("router");

  window.location.href = window.location.href;
  return;
  router.push("/");
}

function roleCall() {
  console.log("pageData", pageData);

  // roleId 为 null 或 -1 时移除 localStorage，避免存入字符串 "null"
  if (pageData.roleId != null && pageData.roleId !== -1) {
    localStorage.setItem("roleId", pageData.roleId);
  } else {
    localStorage.removeItem("roleId");
  }
  projectListCall();

  localStorage.setItem("loginId", pageData.projectId);

  localStorage.setItem("getInfoShow", true);
}
async function projectCall() {
  // if (useUserStore().permissions[0] != "*:*:*") {
  //   projectListCall();
  //   return;
  // }

  // 角色下拉只是"按角色排序"的筛选器；没有 system:role:list 的账号
  // （演示/只读）发这个请求必被后端拒（Access Denied），直接跳过。
  if (!auth.hasPermi("system:role:list")) {
    pageData.roleList = [{ roleId: -1, roleName: "不按角色排序" }];
    pageData.roleId = null;
    return;
  }

  var data = pageData.projectList.find((item) => {
    if (pageData.projectId == item.projectId) return item;
  });

  let result = await listRole({
    pageNum: 1,
    pageSize: -1,
    deptId: data.deptId,
  });

  pageData.roleList = result.rows;
  pageData.roleList.unshift({
    roleId: -1,
    roleName: "不按角色排序",
  });
  pageData.roleId = null;
}

async function handleChange(value) {
  var projectId, moduleId;
  if (value == undefined) {
    projectId = undefined;
    moduleId = undefined;
  } else {
    projectId = value[0];
    moduleId = value[1];
  }
  console.log("变化:", value);

  setItem("projectId", projectId);
  setItem("moduleId", moduleId);

  var projectList = pageData.projectList.filter((item) => {
    if (projectId == item.projectId) return item;
  });

  var moduleList = pageData.moduleList.filter((item) => {
    if (moduleId == item.moduleId) return item;
  });

  setItem(
    "projectName",
    projectList == undefined || projectList.length == 0
      ? undefined
      : projectList[0].projectName,
  );
  setItem(
    "moduleName",
    moduleList == undefined || moduleList.length == 0
      ? undefined
      : moduleList[0].moduleName,
  );

  let d = await permissionStore.generateRoutes({
    projectId: projectId,
  });
  // 修改logo旁边
  useDeviceStore().updataPageTitle(projectList[0].projectName);

  localStorage.setItem("routerPage", d[0].children[0].path);

  // 设置项目切换标志，用于清除页面缓存
  sessionStorage.setItem("projectChanged", "true");
  // 清除旧路由缓存，避免切换项目后导航到旧项目的路由
  sessionStorage.removeItem("router");

  window.location.href = window.location.href;

  return;
}
function setItem(key, value) {
  console.log(value);
  console.log(value == undefined);
  if (value == undefined) localStorage.removeItem(key);
  else localStorage.setItem(key, value);
}

function toggleSideBar() {
  appStore.toggleSideBar();
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    case "clearCache":
      clearCache();
      break;
    default:
      break;
  }
}

function logout() {
  ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      clearSessionCache();
      userStore.logOut().then(() => {
        location.href = "/login";
      });
    })
    .catch(() => {});
}

/** 强制回到干净态：全清前端缓存（含登录 token 与「上次使用项目」），清完必然重新登录 */
function clearCache() {
  ElMessageBox.confirm(
    "将清空本机全部缓存（含登录状态与上次使用的项目），清空后需重新登录。确定继续？",
    "提示",
    { confirmButtonText: "确定清理", cancelButtonText: "取消", type: "warning" }
  )
    .then(() => {
      clearAllClientCache();
      location.href = "/login";
    })
    .catch(() => {});
}

const emits = defineEmits(["setLayout"]);
function setLayout() {
  emits("setLayout");
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 40px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
